import React from 'react';
import {
  DEFAULT_PLANTAFEL_DISPLAY_SETTINGS,
  type PlantafelDisplaySettings,
} from '../../utils/plantafelSettings';

export const PlantafelTimelineRowRefContext = React.createContext<
  React.RefObject<HTMLDivElement | null> | null
>(null);

export const PlantafelDisplayContext = React.createContext<PlantafelDisplaySettings>(
  DEFAULT_PLANTAFEL_DISPLAY_SETTINGS,
);

export function usePlantafelDisplay(): PlantafelDisplaySettings {
  return React.useContext(PlantafelDisplayContext);
}
